import React from "react";
import PropTypes from "prop-types";
import {FaRegularIcon, FaSolidIcon} from "../../../components/FontAwesomeIcons";

export class CreateEventParticipantsStep extends React.Component {
    constructor(props) {
        super(props);
        this.optionCardStyle = {
            cursor: "pointer",
            minHeight: "92px",
        };
        this.optionCardSelectedStyle = {
            cursor: "pointer",
            minHeight: "92px",
            borderColor: "#293069",
            borderWidth: "1px",
        };
        this.iconBoxStyle = {
            width: "42px",
            minWidth: "42px",
            height: "42px",
        };
    }

    handleNameModeChange = mode => _ => this.props.onDataChange("participantsNameMode")(mode)

    handleApprovalModeChange = e => {
        this.props.onDataChange("guestsApprovalMode")(e.target.checked ? "confirmed" : "approval_required");
    }

    isNameModeSelected = mode => this.props.eventData.participantsNameMode === mode

    isApprovalAutomatic = _ => this.props.eventData.guestsApprovalMode === "confirmed"

    canShowExpectedParticipantsInput = _ => this.props.eventData.expectedParticipantsEnabled

    canShowMaxParticipantsPerReservationInput = _ => this.props.eventData.maxParticipantsPerReservationEnabled

    getMaxParticipantsPerReservationLimit = _ => this.props.eventData.expectedParticipantsEnabled ?
        this.props.eventData.expectedParticipants : null

    render() {
        return (
            <div className={"container py-3"}>
                <div className={"mb-3"}>
                    <h5 className={"font-weight-bold mb-1"}>Gestione partecipanti</h5>
                    <div className={"text-muted"}>Configura come raccogliere le adesioni degli invitati.</div>
                </div>

                <div className={"mb-3"}>
                    <div className={"font-weight-bold mb-2"}>
                        <span className={"text-magenta mr-1"}>
                            <FaSolidIcon name={"users"}/>
                        </span>
                        Come vuoi raccogliere i nomi?
                    </div>
                    <div className={"row"}>
                        <div className={"col-6 pr-2"}>
                            <div
                                className={`card h-100 ${this.isNameModeSelected("all") ? "shadow-sm" : "border-0 shadow-sm"}`}
                                style={this.isNameModeSelected("all") ? this.optionCardSelectedStyle : this.optionCardStyle}
                                onClick={this.handleNameModeChange("all")}
                            >
                                <div className={"card-body p-3"}>
                                    <div className={"font-weight-bold"}>Tutti i nomi</div>
                                    <div className={"small text-muted"}>Ogni invitato inserisce il proprio nome.</div>
                                </div>
                            </div>
                        </div>
                        <div className={"col-6 pl-2"}>
                            <div
                                className={`card h-100 ${this.isNameModeSelected("main_with_count") ? "shadow-sm" : "border-0 shadow-sm"}`}
                                style={this.isNameModeSelected("main_with_count") ? this.optionCardSelectedStyle : this.optionCardStyle}
                                onClick={this.handleNameModeChange("main_with_count")}
                            >
                                <div className={"card-body p-3"}>
                                    <div className={"font-weight-bold"}>Capo gruppo</div>
                                    <div className={"small text-muted"}>Un nome e il numero dei partecipanti.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"card border-0 shadow-sm overflow-hidden mb-3"}>
                    <div className={"p-3 border-bottom"}>
                        <div className={"d-flex align-items-center"}>
                            <div
                                className={"rounded bg-light d-flex align-items-center justify-content-center text-magenta mr-3"}
                                style={this.iconBoxStyle}
                            >
                                <FaSolidIcon name={"user-friends"}/>
                            </div>
                            <div className={"flex-grow-1"}>
                                <div className={"font-weight-bold"}>Numero partecipanti totali</div>
                                <div className={"small text-muted"}>Imposta un numero massimo complessivo di partecipanti.</div>
                            </div>
                            <div className={"custom-control custom-switch"}>
                                <input
                                    type={"checkbox"}
                                    className={"custom-control-input"}
                                    id={"userEventExpectedParticipantsEnabled"}
                                    checked={this.props.eventData.expectedParticipantsEnabled}
                                    onChange={this.props.onCheckboxChange("expectedParticipantsEnabled")}
                                />
                                <label className={"custom-control-label"} htmlFor={"userEventExpectedParticipantsEnabled"}/>
                            </div>
                        </div>
                        {
                            this.canShowExpectedParticipantsInput() &&
                            <div className={"mt-3"}>
                                <label className={"small font-weight-bold"}>Partecipanti totali</label>
                                <input
                                    type={"number"}
                                    min={"1"}
                                    step={"1"}
                                    className={"form-control"}
                                    value={this.props.eventData.expectedParticipants}
                                    onChange={this.props.onInputChange("expectedParticipants")}
                                />
                            </div>
                        }
                    </div>

                    <div className={"p-3"}>
                        <div className={"d-flex align-items-center"}>
                            <div
                                className={"rounded bg-light d-flex align-items-center justify-content-center text-magenta mr-3"}
                                style={this.iconBoxStyle}
                            >
                                <FaSolidIcon name={"users-cog"}/>
                            </div>
                            <div className={"flex-grow-1"}>
                                <div className={"font-weight-bold"}>Partecipanti per conferma</div>
                                <div className={"small text-muted"}>Limita il numero massimo per singola adesione.</div>
                            </div>
                            <div className={"custom-control custom-switch"}>
                                <input
                                    type={"checkbox"}
                                    className={"custom-control-input"}
                                    id={"userEventMaxParticipantsPerReservationEnabled"}
                                    checked={this.props.eventData.maxParticipantsPerReservationEnabled}
                                    onChange={this.props.onCheckboxChange("maxParticipantsPerReservationEnabled")}
                                />
                                <label className={"custom-control-label"} htmlFor={"userEventMaxParticipantsPerReservationEnabled"}/>
                            </div>
                        </div>
                        {
                            this.canShowMaxParticipantsPerReservationInput() &&
                            <div className={"mt-3"}>
                                <label className={"small font-weight-bold"}>Massimo per conferma</label>
                                <input
                                    type={"number"}
                                    min={"1"}
                                    max={this.getMaxParticipantsPerReservationLimit()}
                                    step={"1"}
                                    className={`form-control ${this.props.hasMaxParticipantsPerReservationError ? "is-invalid" : ""}`}
                                    value={this.props.eventData.maxParticipantsPerReservation}
                                    onChange={this.props.onInputChange("maxParticipantsPerReservation")}
                                />
                                {
                                    this.props.hasMaxParticipantsPerReservationError &&
                                    <div className={"invalid-feedback d-block"}>
                                        Il massimo per conferma non può superare i partecipanti totali.
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>

                <div className={"card border-0 shadow-sm overflow-hidden"}>
                    <div className={"d-flex align-items-center p-3 border-bottom"}>
                        <div
                            className={"rounded bg-light d-flex align-items-center justify-content-center text-magenta mr-3"}
                            style={this.iconBoxStyle}
                        >
                            <FaSolidIcon name={"utensils"}/>
                        </div>
                        <div className={"flex-grow-1"}>
                            <div className={"font-weight-bold"}>Mostra campo intolleranze</div>
                            <div className={"small text-muted"}>Gli invitati potranno segnalare allergie.</div>
                        </div>
                        <div className={"custom-control custom-switch"}>
                            <input
                                type={"checkbox"}
                                className={"custom-control-input"}
                                id={"userEventShowIntolerances"}
                                checked={this.props.eventData.showIntolerances}
                                onChange={this.props.onCheckboxChange("showIntolerances")}
                            />
                            <label className={"custom-control-label"} htmlFor={"userEventShowIntolerances"}/>
                        </div>
                    </div>

                    <div className={"d-flex align-items-center p-3 border-bottom"}>
                        <div
                            className={"rounded bg-light d-flex align-items-center justify-content-center text-magenta mr-3"}
                            style={this.iconBoxStyle}
                        >
                            <FaRegularIcon name={"sticky-note"}/>
                        </div>
                        <div className={"flex-grow-1"}>
                            <div className={"font-weight-bold"}>Mostra campo note</div>
                            <div className={"small text-muted"}>Un campo libero per messaggi all'organizzatore.</div>
                        </div>
                        <div className={"custom-control custom-switch"}>
                            <input
                                type={"checkbox"}
                                className={"custom-control-input"}
                                id={"userEventShowNotes"}
                                checked={this.props.eventData.showNotes}
                                onChange={this.props.onCheckboxChange("showNotes")}
                            />
                            <label className={"custom-control-label"} htmlFor={"userEventShowNotes"}/>
                        </div>
                    </div>

                    <div className={"d-flex align-items-center p-3"}>
                        <div
                            className={"rounded bg-light d-flex align-items-center justify-content-center text-magenta mr-3"}
                            style={this.iconBoxStyle}
                        >
                            <FaRegularIcon name={"check-circle"}/>
                        </div>
                        <div className={"flex-grow-1"}>
                            <div className={"font-weight-bold"}>Approvazione automatica</div>
                            <div className={"small text-muted"}>Gli invitati sono confermati di default.</div>
                        </div>
                        <div className={"custom-control custom-switch"}>
                            <input
                                type={"checkbox"}
                                className={"custom-control-input"}
                                id={"userEventAutomaticApproval"}
                                checked={this.isApprovalAutomatic()}
                                onChange={this.handleApprovalModeChange}
                            />
                            <label className={"custom-control-label"} htmlFor={"userEventAutomaticApproval"}/>
                        </div>
                    </div>
                </div>

                <div className={"mb-5 pb-4"}/>
            </div>
        );
    }
}

CreateEventParticipantsStep.propTypes = {
    eventData: PropTypes.object,
    onCheckboxChange: PropTypes.func,
    onInputChange: PropTypes.func,
    onDataChange: PropTypes.func,
    hasMaxParticipantsPerReservationError: PropTypes.bool,
};
